/**
 * AddChannelsCtrl controller
 * Add Channels to Category
 */

// controller mixins
AddChannelsCtrl.mixes = [
  ['m2mCtrlMixin', 'cat', 'channels']
]

/**
 * AddChannelsCtrl controller
 *
 * @class AddChannelsCtrl
 * @memberof mwApp/sets
 * @see mwApp/sets
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/sets.controller:AddChannelsCtrl
 */
/* @ngInject */
export default function AddChannelsCtrl ($uibModalInstance, Channel, cat, set) {
  var vm = this

  /**
   * Category
   *
   * @memberof mwApp/sets.controller:AddChannelsCtrl
   * @type {models.Category}
   */
  vm.cat = cat

  /**
   * CategorySet
   *
   * @memberof mwApp/sets.controller:AddChannelsCtrl
   * @type {models.CategorySet}
   */
  vm.set = set

  /**
   * Search content params with default values
   *
   * @memberof mwApp/sets.controller:AddChannelsCtrl
   * @type {Object}
   */
  vm.searchContentParams = {
    q: '',
    page: 0,
    last: false
  }

  /**
   * Filter content, it seems that this works faster, then filter in ui-select-choices
   *
   * @memberof mwApp/sets.controller:AddChannelsCtrl
   * @param  {Object} $select
   */
  vm.$timerContent = 0
  vm.openCountContent = 0
  vm.refreshContent = function ($select = {}) {
    vm.openCountContent = $select.open
      ? vm.openCountContent + 1
      : 0

    if (vm.openCountContent > 1) {
      vm.searchContentParams.q = $select.search
    }

    if (vm.openCountContent === 1) {
      $select.search = vm.searchContentParams.q
    }

    if ($select.open) {
      window.clearTimeout(vm.$timerContent)
      vm.$timerContent = window.setTimeout(() => {
        let search = $select.search || ''

        vm.searchContentParams.page = 0

        vm.searchContentParams.q = search

        search = search ? search.toLowerCase() : ''
        Channel.search(
          `api/sets/${vm.set.id}/categories/${vm.cat.id}/extra/channels`,
          {
            q: search,
            page: 0
          }
        )
          .then((result) => {
            vm.channels = result.content.filter(vm.filterChannels)
            if (vm.channels.length === 0) {
              getChannels()
            }
          })
      }, vm.openCountContent === 1 ? 0 : 700)
    }
  }
  const getChannels = function () {
    const {
      last,
      q
    } = vm.searchContentParams
    if (!last) {
      vm.searchContentParams.page++
      Channel.search(
        `api/sets/${vm.set.id}/categories/${vm.cat.id}/extra/channels`,
        {
          q,
          page: vm.searchContentParams.page
        }
      )
        .then((result) => {
          vm.searchContentParams.last = result.last
          vm.channels = vm.channels.concat(result.content.filter(vm.filterChannels))
          if (vm.channels.length === 0) {
            getChannels()
          }
        })
    }
  }

  /**
   * Handler for scroll event of select list
   *
   * @param event
   */
  vm.$timerContentScroll = 0
  vm.contentCallbackScroll = (event) => {
    const {
      last,
      q
    } = vm.searchContentParams
    if (!last && event.wheelDelta < 0 && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerContentScroll)
      vm.$timerContentScroll = window.setTimeout(() => {
        vm.searchContentParams.page++
        Channel.search(
          `api/sets/${vm.set.id}/categories/${vm.cat.id}/extra/channels`,
          {
            q,
            page: vm.searchContentParams.page
          }
        )
          .then((result) => {
            vm.searchContentParams.last = result.last
            vm.channels = vm.channels.concat(result.content.filter(vm.filterChannels))
          })
      }, 300)
    }
  }

  vm.filterChannels = function (channel) {
    return !vm.cat.channels.find(ch => ch.id === channel.id)
  }

  /**
   * Save
   *
   * @memberof mwApp/sets.controller:AddChannelsCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    cat._clone()
      ._modify(function (cat) {
        cat.categorySet = null
        cat.parentCategory = null
        cat.subCategories = null
        cat.sortOrder = null
      })
      ._save()
      .then(
        () => {
          $uibModalInstance.close()
        }
      ).finally(vm.unsetDisable)
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/sets.controller:AddChannelsCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
